import { Component, Input } from '@angular/core';
import { RiskProxySecurity } from '@ddt-web/wealth-web';

@Component({
	selector: 'hl-proxy-list-item',
	templateUrl: './proxy-list-item.component.html',
	styleUrls: ['./proxy-list-item.component.scss']
})
export class ProxyListItemComponent {
	@Input() public security: RiskProxySecurity;
}
